








































import FilterCard from "@/components/filter/FilterCard.vue";
import { getFlagEmoji } from "@/lib/CountryCodeHelper";
import { CountryCodeEnum } from "@/lib/enum/country-code.enum";
import { IFilterListElement } from "@/lib/interfaces/filter/filterListElement.interface";
import { simpleDate } from "@/lib/utility/date-helper";
import { getDateFilterList } from "@/lib/utility/filter";
import { thgStatusMap } from "@/lib/utility/thgStatusMap";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { ThgThgViewModelGen } from "@/services/thg/v1/data-contracts";
import { ThgStatusEnum } from "@/store/enum/thg/thg-status.enum";
import { UserAdministrationModule } from "@/store/modules/admin-user.store";
import { ThgPaginationModule } from "@/store/modules/thg-pagination.store";
import { ThgPortalModule } from "@/store/modules/thg.portal.store";
import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import TheLayoutPortalList from "../../layouts/TheLayoutPortalList.vue";

@Component({
  components: {
    FilterCard,
    TheLayoutPortalList
  }
})
export default class ThgListAdmin extends mixins(DarkModeHighlightMixin, PartnerFallbackMixin) {
  @Prop()
  loading!: boolean;

  isLoadingMore = false;

  isLoadingDetail = false;

  CountryCodeEnum = CountryCodeEnum;

  statusFilter = [
    {
      label: String(this.$t("components.partner.PartnerReportList.progressStatus")),
      value: [],
      items: Object.values(ThgStatusEnum),
      multiple: true,
      conditionCheck: (obj: ThgThgViewModelGen, condition: string) => {
        return obj.status === condition;
      }
    }
  ];

  dateFilter = getDateFilterList("timestamp");

  get filterList(): IFilterListElement[] {
    return [...this.dateFilter, ...this.statusFilter];
  }

  get paginationList() {
    return ThgPaginationModule.paginationList;
  }

  getModule() {
    return ThgPaginationModule;
  }

  async set(item: any) {
    this.setIsLoadingDetail(true);
    if (["xs", "sm"].includes(this.$vuetify.breakpoint.name)) {
      this.$router.push({ name: "ThgQuoteDetailView", params: { thgId: item.id, partnerId: item.partnerId } });
    } else {
      const thg = await ThgPortalModule.getSelectedThgByPartnerID({
        thgId: item.id,
        partnerId: item.partnerId
      });
      ThgPaginationModule.replaceInList(thg);
      if (!thg) {
        Vue.$toast.error(String(this.$t("components.partner.PartnerReportList.noQuoteFound")));
      }
      const user = await UserAdministrationModule.getSelectedUser(item.userId);
      if (!user) {
        Vue.$toast.error(String(this.$t("components.partner.PartnerReportList.noUserFound")));
      }
    }
    this.setIsLoadingDetail(false);
  }

  async refresh() {
    this.$emit("refresh");
  }

  async loadMore() {
    try {
      this.isLoadingMore = true;
      await ThgPaginationModule.fetchNext({});
    } catch (e) {
      this.$toast.error((e as any).message);
    } finally {
      this.isLoadingMore = false;
    }
  }

  isActive(item: any) {
    return item.id === ThgPortalModule.selectedThg.id ? `grey ${this.color}` : "";
  }

  date(item: any): string {
    return simpleDate(item.timestamp?.created);
  }

  thgStatus(thgStatusEnum: any) {
    return (
      thgStatusMap.get(thgStatusEnum) || {
        text: "Alles im grünen Bereich.",
        icon: "mdi-help",
        portalText: thgStatusEnum
      }
    );
  }

  getFlag(countryCode: string) {
    return getFlagEmoji(countryCode);
  }

  setIsLoadingDetail(status: boolean) {
    this.isLoadingDetail = status;
    this.$emit("isLoadingDetail", status);
  }
}
